import { createNoParamsFetcher } from '../contexts/Fetcher';
import { apiProductPlan } from '../resources/api/apiProductPlan';

const { useGetPlans } = apiProductPlan;

export const ProductPlansFetcher = createNoParamsFetcher(() => useGetPlans().execute);
